export default __webpack_public_path__ + "static/media/agriculture.1c22d1a8.png";